import { LinkOutlined } from '@ant-design/icons';
import { type BaseOptionsType, CONDITION_KEY_OPTIONS } from 'advanced-filters/data';
import { type AdvancedFilterButtonProps } from 'advanced-filters/types/advancedFilterButton';
import { ConfigProvider } from 'antd';
import { useMemo } from 'react';

import FilterList from '../FilterList';
import SearchCriteria from '../SearchCriteria';
import styles from './FilterContainer.module.scss';

function Seperator() {
  return (
    <div className={styles.seperatorContent}>
      <span className={styles.seperator} />
      <LinkOutlined className={styles.seperatorIcon} />
      <span className={styles.seperator} />
    </div>
  );
}

/**
 * @description Entry Point for Advanced Filter
 * Renders the Advanced Filter Cards and Search Criteria
 */
export default function FilterContainer({
  footerConfig,
  additionalConditionKeys = [],
  excludedDefaultKeys = [],
}: {
  footerConfig: AdvancedFilterButtonProps[];
  additionalConditionKeys?: BaseOptionsType[];
  excludedDefaultKeys?: string[];
}) {
  const conditionKeys = useMemo(() => [
    ...additionalConditionKeys,
    ...CONDITION_KEY_OPTIONS.filter((key) => !excludedDefaultKeys.includes(key.value)),
  ], [additionalConditionKeys, excludedDefaultKeys]);

  return (
    <ConfigProvider componentSize="large">
      <div className={styles.container}>
        <SearchCriteria conditionKeys={conditionKeys} />
        <Seperator />
        <FilterList footerConfig={footerConfig} />
      </div>
    </ConfigProvider>
  );
}
